import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";

import { CacheDataSource } from "./cache.datasource";
import { ENVIRONMENT } from "../../core/token";

@Injectable()
export class CompaniesDataSource extends CacheDataSource {
	private api_url: string = "hola";

	constructor(@Inject(ENVIRONMENT) protected environment, httpClient: HttpClient) {
		super(httpClient);

		this.api_url = environment.api_url;
		this.setPath(this.api_url + "/v2/clients");
	}
}
